let _accessToken = null

export const setAccessToken = (token) => {
    _accessToken = token
}

export const getAccessToken = () => _accessToken

export const clearTokens = () => {
    _accessToken = null
}

// Odświeżenie access tokena z blokadą między kartami (Web Locks API).
// Backend rotuje refresh token (jest jednorazowego użytku), a cookie jest wspólne dla całej przeglądarki,
// więc dwa równoległe refreshe z różnych kart unieważniłyby sobie nawzajem sesję.
export const refreshAccessToken = async (api) => {
    const doRefresh = async () => {
        const res = await api.post("/api/v1/Authentication/refreshToken", {}, { withCredentials: true })
        if (res.data && res.data.accessToken) {
            setAccessToken(res.data.accessToken)
        }
        return getAccessToken()
    }

    if (navigator.locks) {
        return navigator.locks.request('eh_refresh_token', doRefresh)
    }
    return doRefresh()
}